import React, { useState, useEffect, useContext, useCallback, useRef } from 'react';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import "mapbox-gl/dist/mapbox-gl.css";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import mapboxgl from "mapbox-gl";
import useMediaQuery from '@material-ui/core/useMediaQuery';

import MapboxDraw from "@mapbox/mapbox-gl-draw";

import { geoFilter } from './Utils';

export const token = 'pk.eyJ1IjoiZHJrZWlyIiwiYSI6ImNrZm04MGdkZjFmczIydXBtYXB3azhqdHEifQ.e3XpW4pI5WDNZeFJT9vRUw';

// see https://github.com/mapbox/mapbox-gl-draw/blob/main/src/lib/theme.js
const drawColor = "rgb(206,218,190)"; // "#D20C0C";
const drawStyles = [
    // ACTIVE (being drawn)
    // polygon fill
    {
      "id": "gl-draw-polygon-fill",
      "type": "fill",
      "filter": ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
      "paint": {
        "fill-color": drawColor,
        "fill-outline-color": drawColor,
        // "fill-opacity": 0.8
      }
    },
    // polygon outline stroke
    // This doesn't style the first edge of the polygon, which uses the line stroke styling instead
    {
      "id": "gl-draw-polygon-stroke-active",
      "type": "line",
      "filter": ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
      "layout": {
        "line-cap": "round",
        "line-join": "round"
      },
      "paint": {
        "line-color": drawColor,
        "line-dasharray": [0.2, 2],
        "line-width": 2
      }
    },
    // vertex point halos
    {
      "id": "gl-draw-polygon-and-line-vertex-halo-active",
      "type": "circle",
      // "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
      "paint": {
        "circle-radius": 5,
        "circle-color": "#FFF"
      }
    },
    // vertex points
    {
      "id": "gl-draw-polygon-and-line-vertex-active",
      "type": "circle",
      // "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
      "paint": {
        "circle-radius": 3,
        "circle-color": drawColor,
      }
    },

    // INACTIVE (static, already drawn)
    // polygon fill
    {
      "id": "gl-draw-polygon-fill-static",
      "type": "fill",
      "filter": ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
      "paint": {
        "fill-color": "#000",
        "fill-outline-color": "#000",
        "fill-opacity": 0.8
      }
    },
    // polygon outline
    {
      "id": "gl-draw-polygon-stroke-static",
      "type": "line",
      "filter": ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
      "layout": {
        "line-cap": "round",
        "line-join": "round"
      },
      "paint": {
        "line-color": "#000",
        "line-width": 3
      }
    }
  ]


// const hoverListener = (map, setHoveredSA2) => {
//     var hoveredStateId = null;
//     // When the user moves their mouse over the state-fill layer, we'll update the
//     // feature state for the feature under the mouse.
//     map.on('mousemove', 'sa2-layer', function(e) {
//         if (e.features.length > 0) {
//             if (hoveredStateId) {
//                 map.setFeatureState(
//                     { source: 'sa2-layer', id: hoveredStateId },
//                     { hover: false }
//                 );
//             }
//             hoveredStateId = e.features[0].id;
//             map.setFeatureState(
//                 { source: 'sa2-layer', id: hoveredStateId },
//                 { hover: true }
//             );
//             setHoveredSA2(hoveredStateId)
//         }
//     });

//     // When the mouse leaves the state-fill layer, update the feature state of the
//     // previously hovered feature.
//     map.on('mouseleave', 'sa2-layer', function() {
//         if (hoveredStateId) {
//             map.setFeatureState(
//                 { source: 'sa2-layer', id: hoveredStateId },
//                 { hover: false }
//             );
//         }
//         hoveredStateId = null;
//         setHoveredSA2(hoveredStateId)
//     });
// }

export default function MapContainer({ layers, mapRef, buildings }) {
  const mapContainer = useRef();
  // TODO
  // const mapRef = useRef();
  // const geocodeRef = useRef();
  // const { mapRef, geocodeRef } = useContext(mapState);

  const isTouchScreen = useMediaQuery('(pointer:coarse)');
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const map = new mapboxgl.Map({
      accessToken: token,
      container: mapContainer.current,
      center: [153.0184, -27.4663],
      pitch: 60,
      zoom: 13,
      // style: 'mapbox://styles/giraffetechnology/ckbvl6yqh03ip1iqi5meojs7c',
      style: 'mapbox://styles/drkeir/ckfn5fgps0aoc19nmplatpe2y',
      // style: 'mapbox://styles/mapbox/streets-v11',
      // TODO rerender map when taking vista screenshot with this set to true, otherwise should be false
      // preserveDrawingBuffer: true
    });
    mapRef.current = map
    // map.boxZoom.disable();

    var draw = new MapboxDraw({
      displayControlsDefault: false,
      controls: {
        polygon: true,
        trash: true
      },
      styles: drawStyles
    });
    map.addControl(draw, 'top-right');

    const updateArea = () => {
      // const [parks, setParks] = React.useState({type: 'FeatureCollection', features: []})
      const parks = draw.getAll()
      const filteredBuildings = geoFilter(buildings, parks);
      const notFilter = ["all", ...filteredBuildings.map(id => ["!=", "id", id])];
      map.setFilter('3d-building-layer', notFilter);

    }

    map.on('draw.create', updateArea);
    map.on('draw.delete', updateArea);
    map.on('draw.update', updateArea);

    map.on('load', () => {

      // var mboxlayers = map.getStyle().layers;
      // Find the index of the first symbol layer in the map style
      // var firstSymbolId;
      // for (var i = 0; i < mboxlayers.length; i++) {
      //     if (mboxlayers[i].type === 'symbol') {
      //         firstSymbolId = mboxlayers[i].id;
      //         break;
      //     }
      // }
      var firstSymbolId = 'road-label-simple'
      
      map.moveLayer("gl-draw-polygon-fill.cold", firstSymbolId)
      map.moveLayer("gl-draw-polygon-fill.hot", firstSymbolId)
      map.moveLayer("gl-draw-polygon-fill-static.cold", firstSymbolId)
      map.moveLayer("gl-draw-polygon-fill-static.hot", firstSymbolId)
    })

    // TODO 
    // const geocoder = new MapboxGeocoder({
    //   accessToken: token,
    //   mapboxgl: mapboxgl,
    //   marker: true,
    //   placeholder: 'Search Map',
    //   flyTo: { speed: 4 }
    // });
    // geocodeRef.current.appendChild(geocoder.onAdd(map));
    // geocoder.on('result', result => {
    //   const [longitude, latitude] = result.result.center;
    //   map.resize();
    // })

    isTouchScreen && map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');

    map.on("style.load", () => {
      setLoaded(true);

      // hoverListener(map, setHoveredSA2)

    });

  }, []);


  useEffect(() => {
    const { current: map } = mapRef;
    if (!map) return
    if (!loaded) return

    window.map = map
    window.layers = layers

    layers.forEach(layer => {
      if (map.getLayer(layer.id)) {
        map.removeLayer(layer.id)
      }
      if (map.getSource(layer.id)) {
        map.removeSource(layer.id)
      }
      map.addLayer(layer, 'road-label-simple')
    })

    }, [loaded])

  useEffect(() => {
    const { current: map } = mapRef;
    if (!map) return
    if (!loaded) return

    map.getSource('3d-building-layer').setData(layers.filter(l => l.id === '3d-building-layer')[0].source.data)

  }, [layers])


  const style = {
    width: '100%',
    height: "calc(100vh)",
  };
  return <div ref={mapContainer} style={style} />;

}